export const MASTER_FIELD_PREFIX = 'master_';
export const RT_MASTER_EMPTY_PLACEHOLDER = '<empty>';
